export default {
    url: '/units_levels',
    template: require('./view.html'),
    data: {
        title: 'Units Levels',
        priority: 900,
    },
    reloadOnSearch: false,
};
